import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import developerImage from '../../../assets/developer.svg';
import './ContactForms.css';
import { Mail, User, Phone, MessageSquare, Send } from '../../Icons';

export const ContactForms = () => {
  const form = useRef();
  const statusResetRef = useRef(null);
  const [submitState, setSubmitState] = useState('idle');

  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const resetButtonStateLater = () => {
    if (statusResetRef.current) clearTimeout(statusResetRef.current);
    statusResetRef.current = setTimeout(() => {
      setSubmitState('idle');
    }, 3200);
  };

  useEffect(() => {
    return () => {
      if (statusResetRef.current) clearTimeout(statusResetRef.current);
    };
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setSubmitState('sending');

    if (!serviceId || !templateId || !publicKey) {
      console.error('EmailJS config missing', {
        hasServiceId: Boolean(serviceId),
        hasTemplateId: Boolean(templateId),
        hasPublicKey: Boolean(publicKey),
      });
      toast.error('Configuracion de EmailJS incompleta', {
        position: 'top-right',
        autoClose: 3500,
        theme: 'dark',
      });
      setSubmitState('error');
      resetButtonStateLater();
      return;
    }

    emailjs.sendForm(serviceId, templateId, form.current, publicKey).then(
      () => {
        setSubmitState('success');
        toast.success('Mensaje enviado con exito!', {
          position: 'top-right',
          autoClose: 3000,
          theme: 'dark',
        });
        form.current.reset();
        resetButtonStateLater();
      },
      (error) => {
        console.error('EmailJS error', {
          status: error?.status,
          text: error?.text,
          name: error?.name,
        });
        toast.error('Hubo un problema al enviar el mensaje', {
          position: 'top-right',
          autoClose: 3000,
          theme: 'dark',
        });
        setSubmitState('error');
        resetButtonStateLater();
      }
    );
  };

  const buttonTextByState = {
    idle: 'Enviar Mensaje',
    sending: 'Enviando...',
    success: 'Enviado',
    error: 'Error, proba de nuevo',
  };

  return (
    <div className='contact-layer'>
      <div className='contact-container-form'>
        <div className='contact-card'>
          <div className='contact-form-column'>
            <div className='content-form-header'>
              <span className='eyebrow'>Contacto</span>
              <h2>Hablemos de tu proximo proyecto</h2>
              <p className='subtitle'>
                Tenes una idea en mente? Contame los detalles y te respondere lo antes posible para empezar a trabajar juntos.
              </p>
            </div>

            <form ref={form} onSubmit={sendEmail} className='contact-form-grid'>
              <div className='form-row'>
                <div className='form-group'>
                  <label htmlFor='user_name'>
                    <User size={16} /> Nombre
                  </label>
                  <input
                    id='user_name'
                    type='text'
                    name='user_name'
                    placeholder='Ej: Agustin Rosano'
                    required
                  />
                </div>
                <div className='form-group'>
                  <label htmlFor='user_email'>
                    <Mail size={16} /> Email
                  </label>
                  <input
                    id='user_email'
                    type='email'
                    name='user_email'
                    placeholder='hola@ejemplo.com'
                    required
                  />
                </div>
              </div>

              <div className='form-group'>
                <label htmlFor='user_phone'>
                  <Phone size={16} /> Telefono (opcional)
                </label>
                <input id='user_phone' type='text' name='user_phone' placeholder='+54 9...' />
              </div>

              <div className='form-group'>
                <label htmlFor='message'>
                  <MessageSquare size={16} /> Tu mensaje
                </label>
                <textarea
                  id='message'
                  name='message'
                  placeholder='Contame un poco sobre tu idea o consulta...'
                  rows='5'
                  required
                />
              </div>

              <div className='form-footer'>
                <button
                  type='submit'
                  className={`submit-btn ${submitState !== 'idle' ? `is-${submitState}` : ''}`}
                  disabled={submitState === 'sending'}
                >
                  <Send size={18} />
                  {buttonTextByState[submitState]}
                </button>
                <p className='response-time'>Respondere en menos de 24 horas.</p>
              </div>
            </form>
          </div>

          <div className='contact-visual-side'>
            <div className='visual-box'>
              <img src={developerImage} alt='Agustin Rosano' className='floating-img' />
              <div className='status-tag'>
                <span className='status-dot'></span>
                Disponible ahora
              </div>
            </div>
            <div className='info-cards'>
              <div className='info-item'>
                <h4>Ubicacion</h4>
                <p>Buenos Aires, Argentina</p>
              </div>
              <div className='info-item'>
                <h4>Zona Horaria</h4>
                <p>GMT-3 (Argentina)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer toastStyle={{ zIndex: 10001 }} style={{ zIndex: 10001 }} />
    </div>
  );
};
